import {Component, Input, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {HttpResponse, HttpErrorResponse, HttpHeaders} from '@angular/common/http';
import {Observable} from 'rxjs';
import {ITransaction, Transaction} from '../../shared/model/transaction.model';
import {Customer, ICustomer} from '../../shared/model/customer.model';
import {TransactionService} from './transaction.service';
import {CustomerService} from '../customer/customer.service';
import {NgbActiveModal, NgbModal, NgbRatingConfig} from '@ng-bootstrap/ng-bootstrap';
import {ActionType, IActionType} from '../../shared/model/action-type.model';
import {ActionTypeService} from '../action-type/action-type.service';
import {User} from '../../core/user/user.model';
import {UserService} from '../../core/user/user.service';
import * as moment from 'jalali-moment';
import {NgxSpinnerService} from 'ngx-spinner';
import {ActionTypeUpdateComponent} from '../action-type/action-type-update.component';
import {Organization} from '../../shared/model/organization.model';
import {Employee, IEmployee} from '../../shared/model/employee.model';
import {EmployeeService} from '../../core/employee/employee.service';
import {PhoneService} from '../phone/phone.service';
import {IPhone} from '../../shared/model/phone.model';
import {Contract, IContract} from '../../shared/model/contract.model';
import {ContractService} from '../contract/contract.service';
import {IProject, Project} from '../../shared/model/project.model';
import {ProjectService} from '../project/project.service';
import {FileObject, IFileObject} from "../../shared/model/file-object.model";
import {JhiDataUtils} from "ng-jhipster";
import {FileUploadService} from "../file/file-upload-service";
import {FileObjectService} from "../file/file-object.service";
import {ToastrService} from "ngx-toastr";
import {AccountService} from "../../singelton/account.service";
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ISalesCycle, SalesCycle} from "../../shared/model/salesCycle.model";
import {EventService} from "../../singelton/event.service";
import {IStep} from "../../shared/model/step.model";
import {StepService} from "../step/step.service";
import { SHOW_SMS, TRANSACTION_DESCRIPTION_REQUIRED} from "../../app.constants";

@Component({
  selector: 'app-transaction-update-periodic',
  templateUrl: './transaction-update-periodic.component.html',
  styleUrls: ['./transaction.component.scss']

})
export class TransactionUpdatePeriodicComponent implements OnInit {
  @Input() transactionEdit;
  @Input() projects_list;
  @Input() salesCycles_list;
  @Input() contracts_list;
  @Input() phones_list;
  @Input() employees_list;
  @Input() customerId;
  @Input() customer_project_param;
  @Input() customer_contract_param;
  @Input() customer_contract_param_id;
  @Input() customer_salesCycle_param;
  @Input() type;
  @Input() part;
  @Input() action;
  @Input() fromWorkbench = false;

  @Input() file_id;
  @Input() title;
  @Input() role;
  @Input() token;

  show_sms: any = SHOW_SMS;
  transactionDescriptionRequired = TRANSACTION_DESCRIPTION_REQUIRED;
  // business_tyep: any = BUSINESS_TYPE;

  fileObjects: IFileObject[] = [];
  showAddParam: boolean;
  editFormFile = this.fb.group({
    id: [],
    title: [],
    itemName: [],
    size: [],
    content: [],
    isImgProfile: [],
    imgProfile: [],
    status: [],
    uploaded_by: [],
    contentType: []
  });
  param1: any;
  file: IFileObject = new FileObject();
  file_fileType: any;
  file_size: any;
  file_itemName: any;
  sortList: any;
  readonly = true;
  selected = 0;
  hovered = 0;

  profileImg: IFileObject;
  file_doctor: IFileObject;
  form: FormGroup;
  progress = 0;


  disableForm = false;
  project_step: any;
  actionType: IActionType = new ActionType();
  transaction: ITransaction = new Transaction();
  transaction_new: ITransaction = new Transaction();
  peygiry: ITransaction = new Transaction();
  isSaving: boolean;
  isSavingTransaction = false;
  customer: ICustomer = new Customer();
  transaction_step_param = true;
  contracts: IContract[];
  projects: IProject[];
  salseCycles: ISalesCycle[];

  chekNeedFileUpload: Boolean = false;
  chekNeedFollow: Boolean = false;
  chekNeedReminder: Boolean = false;
  customers: ICustomer[];

  dateObject: any;
  dateObject2: any;
  dateObject_follow: any;

  actionTypes: IActionType[];
  employees: IEmployee[];
  users: User[];
  error: any;
  success: any;
  routeData: any;
  links: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  isDisabledPeygiri = true;
  phones: IPhone[];
  steps: IStep[];


  keyword = 'title';
  audience_keyword = 'audience';
  audience_default = '';


  dropdownList = [];
  selectedItems = [];
  dropdownSettings = {};

  selectEvent(item) {
    this.transaction.customer = new Customer(item.id);
    this.loadAllProjectWithCustomerId(item.id);
  }

  onChangeSearch(val: string) {
    alert(' in onChangeSearch');
    alert(moment.from('1367/11/04', 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD')); // 1989/01/24
    this.customer.title = val;
    this.search(this.page);
  }

  onFocused(e) {
  }

  audience_selectEvent(item) {
    this.transaction.audience = item.audience;
  }

  audience_onChangeSearch(val: string) {
    this.transaction.audience = val;
  }

  audience_onFocused(e) {
  }

  onItemSelect(item: any) {
    console.log(' --- selectedItems ===' + this.selectedItems);
  }

  onDeSelect(item: any) {
    console.log(' --- selectedItems ===' + this.selectedItems);
  }

  onSelectAll(items: any) {
    console.log(' --- selectedItems ===' + this.selectedItems);
  }

  onDeSelectAll(items: any) {
    console.log(' --- selectedItems ===' + this.selectedItems);
  }


  constructor(protected transactionService: TransactionService,
              protected eventService: EventService,
              protected customerService: CustomerService,
              protected employeeService: EmployeeService,
              protected activatedRoute: ActivatedRoute,
              protected activeModal: NgbActiveModal,
              protected actionTypeService: ActionTypeService,
              public stepService: StepService,
              protected userService: UserService,
              private modalService: NgbModal,
              protected contractService: ContractService,
              protected projectService: ProjectService,
              protected phoneService: PhoneService,
              private spinner: NgxSpinnerService,
              protected dataUtils: JhiDataUtils,
              private fb: FormBuilder,
              protected fileObjectService: FileObjectService,
              private toastr: ToastrService,
              public accountService: AccountService,
              config: NgbRatingConfig,
              public fileUploadService: FileUploadService) {

    this.itemsPerPage = 1000;
    this.page = 1;
    this.predicate = 'id';
    this.reverse = 'asc';

    this.form = this.fb.group({
      name: [''],
      avatar: [null]
    });

  }


  ngOnInit() {
    // alert(moment.from('1368/04/31', 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD')); // 1989/01/24
    // alert(moment.from('1400/02/10', 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD')); // 1989/01/24

    this.loadAllStep();
    this.dropdownList = [
      {item_id: 1, item_text: 'ارسال نوتیفکیشن در برنامه'},
      {item_id: 2, item_text: 'ارسال سمس'},
    ];

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'item_id',
      textField: 'item_text',
      selectAllText: 'انتخاب همه',
      searchPlaceholderText: 'جستجو',
      unSelectAllText: 'هیچکدام',
      itemsShowLimit: 1,
      allowSearchFilter: true
    };
    if (this.customer_contract_param_id) {
      this.transaction.contract_str = this.customer_contract_param_id;
      this.transaction.contract = this.customer_contract_param;
    }

    this.isSaving = false;
    if (this.transactionEdit) {
      this.spinner.show();
      this.transactionService.find(this.transactionEdit).subscribe(
        (res: HttpResponse<ITransaction>) => {
          this.transaction = res.body;
          if (this.transaction && this.transaction.project && this.transaction.project.id) {
            this.transaction.project_str = this.transaction.project.id;
          }
          if (this.transaction && this.transaction.salesCycle && this.transaction.salesCycle.id) {
            this.transaction.salesCycle_str = this.transaction.salesCycle.id;
          }
          if (this.transaction && this.transaction.contract && this.transaction.contract.id) {
            this.transaction.contract_str = this.transaction.contract.id;
          }

          if (this.transaction.status === 'Completed') {
            // this.disableForm = true;
          }
          if (!(this.transaction.step && this.transaction != null && this.transaction.step !== '')) {
            if (this.customer_project_param && this.customer_project_param.step) {
              this.transaction.step = this.customer_project_param.step;
            }

            if (this.customer_salesCycle_param && this.customer_salesCycle_param.step) {
              this.transaction.step = this.customer_salesCycle_param.step;
            }
            this.transaction_step_param = false;
          }

          if (!this.customer_project_param && this.part === 'other') {
            this.loadAllActionTypesMarketing();
          } else {
            this.loadAllActionTypes();

          }
          this.audience_default = this.transaction.audience;
          if (this.transaction.jalaliDate) {
            const jalaliDate5 = moment(this.transaction.jalaliDate).locale('fa').format('jYYYY/jM/jD HH:mm:ss');

            this.dateObject = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');
            this.dateObject2 = moment(jalaliDate5, 'jYYYY,jMM,jDD  HH:mm:ss');
          }
          if (this.transaction.jalaliDateFollow) {
            const jalaliDate6 = moment(this.transaction.jalaliDateFollow).locale('fa').format('jYYYY/jM/jD HH:mm:ss');

            this.dateObject_follow = moment(jalaliDate6, 'jYYYY,jMM,jDD  HH:mm:ss');
          }

          if (this.customerId) {
            this.transaction.customer = new Customer(this.customerId);
            this.phones = this.phones_list;
            this.employees = this.employees_list;
            this.contracts = this.contracts_list;
            this.projects = this.projects_list;
            this.salseCycles = this.salesCycles_list;

          } else {
            this.phones = this.phones_list;
            this.employees = this.employees_list;
            this.contracts = this.contracts_list;
            this.projects = this.projects_list;
            this.salseCycles = this.salesCycles_list;

            this.search(1);
          }

          if (!this.employees_list) {
            this.loadAllEmployee();
          }
          if (!this.phones_list) {
            this.loadPhone();
          }

        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    } else {
      if (this.customerId) {
        this.transaction.customer = new Customer(this.customerId);
        this.phones = this.phones_list;
        this.employees = this.employees_list;
        this.contracts = this.contracts_list;
        this.projects = this.projects_list;
        this.salseCycles = this.salesCycles_list;

      } else {
        this.phones = this.phones_list;
        this.employees = this.employees_list;
        this.contracts = this.contracts_list;
        this.projects = this.projects_list;
        this.salseCycles = this.salesCycles_list;

      }
    }
    this.transaction.project = this.customer_project_param;
    this.transaction.salesCycle = this.customer_salesCycle_param;

    if (!this.customer_project_param && this.part === 'other') {
      this.loadAllActionTypesMarketing();
    }
    if (!this.employees_list) {
      this.loadAllEmployee();
    }

  }


  loadPhone() {
    this.phoneService.findWithCustomerId(this.customerId).subscribe(
      (res: HttpResponse<IPhone[]>) => {
        this.phones = res.body;
        this.loadAllEmployee();
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }


  search(page) {

    if (page) {
      this.page = page;
    } else {
      this.page = 1;

    }

    this.spinner.show();

    const title = (this.customer.title ? this.customer.title : '');

    this.customerService
      .searchAnutocomplete({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: ['title,asc'],
        title

      })
      .subscribe(
        (res: HttpResponse<ICustomer[]>) => this.paginateCustomers(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );

  }


  protected paginateCustomers(data: ICustomer[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.customers = data;
    this.spinner.hide();
  }

  loadAllCustomer() {
    this.spinner.show();
    this.customerService.query({
      page: this.page - 1,
      size: this.itemsPerPage,
      sort: this.sort_c('title', 'asc')
    }).subscribe((res: HttpResponse<ICustomer[]>) => {
      this.customers = res.body;
      this.spinner.hide();

    }, (res: HttpErrorResponse) => this.onError(res.message));
  }


  sort() {
    const result = [this.predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    if (this.predicate !== 'id') {
      result.push('id');
    }
    return result;
  }

  sort_by_name(predicate) {
    const result = [predicate + ',' + (this.reverse ? 'asc' : 'desc')];
    return result;
  }


  sort_c(predicate, reverse) {
    const result = [predicate + ',' + (reverse ? 'asc' : 'desc')];
    if (predicate !== 'id') {
      result.push('id');
    }
    return result;
  }


  private onSuccess(data, headers) {
    this.totalItems = headers.get('X-Total-Count');
    this.queryCount = this.totalItems;
    this.users = data;
    this.spinner.hide();
  }

  loadAllActionTypesMarketing() {
    this.actionTypeService.query().subscribe(
      (res: HttpResponse<IActionType[]>) => {
        this.actionTypes = res.body;
        this.spinner.hide();
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );

  }


  loadAllStep() {
    this.stepService.query({
      page: this.page - 1,
      size: this.itemsPerPage,
      sort: ['score', 'asc']

    }).subscribe(
      (res: HttpResponse<IStep[]>) => {
        this.steps = res.body;
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  loadAllActionTypes() {
    if (this.transaction.step_number) {
      this.actionTypeService.queryByStep(this.transaction.step_number).subscribe(
        (res: HttpResponse<IActionType[]>) => {
          this.actionTypes = res.body;
          this.spinner.hide();
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    } else {
      this.spinner.hide();

    }
  }


  loadAllContract() {
    this.projects = this.projects_list;
    this.contracts = this.contracts_list;
    this.spinner.hide();
  }


  loadAllProject() {
    this.loadAllContract();
  }


  sort2(predicate, reverse) {
    let result = ['id, desc'];
    if (predicate) {
      result = [predicate + ',' + reverse];
      return result;
    }
  }

  loadAllProjectWithCustomerId(id) {

    const customerId = id;
    this.projectService
      .findWithCustomerId({
        page: this.page - 1,
        size: this.itemsPerPage,
        sort: this.sort2(this.predicate, this.reverse),
        customerId
      }, customerId)
      .subscribe(
        (res: HttpResponse<IProject[]>) => this.paginateProject(res.body, res.headers),
        (res: HttpErrorResponse) => this.onError(res.message)
      );
  }


  protected paginateProject(data: IProject[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.projects = data;
  }

  protected paginateContracts(data: IContract[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.contracts = data;
    this.spinner.hide();
  }


  protected paginateProjects(data: IProject[], headers: HttpHeaders) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;
    this.projects = data;
    this.loadAllContract();

  }

  loadAllEmployee() {
    this.employeeService.query().subscribe(
      (res: HttpResponse<IEmployee[]>) => {
        this.employees = res.body;

        if (!this.customer_project_param && this.part === 'other') {
          this.loadAllActionTypesMarketing();
        } else {
          this.loadAllActionTypes();

        }
      },
      (res: HttpErrorResponse) => this.onError(res.message)
    );
  }

  previousState() {
    window.history.back();
  }


  save() {

    if (this.editFormFile.get(['content']).value && !this.editFormFile.get(['title']).value) {
      alert(' کاربر گرامی لطفاً عنوان فایل آپلود شده را وارد کنید. ');

    } else {
      this.isSaving = true;
      // const span_followDate = document.getElementById('span_followDate');
      this.transaction.employee = new Employee(this.transaction.employee_str);
      if (this.transaction.contract_str) {
        this.transaction.contract = new Contract(this.transaction.contract_str);
      }


      // if (this.transaction.project_str) {
      //   this.transaction.project = new Project(this.transaction.project_str);
      // }
      // if (this.transaction.salesCycle_str) {
      //   this.transaction.salesCycle = new SalesCycle(this.transaction.salesCycle_str);
      // }
      this.transaction.organization = new Organization(1);
      // if (this.customerId) {
      const span_actionDate = document.getElementById('span_actionDate');
      const span_followDate = document.getElementById('span_followDate');
      if (span_actionDate) {
        // alert('span_actionDate).innerHTML='+(<HTMLInputElement>span_actionDate).innerHTML);
        // alert(moment.from((<HTMLInputElement>span_actionDate).innerHTML+'', 'fa', 'YYYY/MM/DD').format('YYYY/MM/DD')); // 1989/01/24

        this.transaction.jalaliDate = (<HTMLInputElement>span_actionDate).innerHTML;
      }
      // }

      // if (!(this.customerId)) {
      //   const span_actionDate = document.getElementById('span_actionDate');
      //   if (span_actionDate) {
      //     this.transaction.jalaliDate = (<HTMLInputElement>span_actionDate).innerHTML;
      //   }
      // }
      if (span_followDate) {
        this.transaction.jalaliDateFollow = (<HTMLInputElement>span_followDate).innerHTML;
      }

      if (this.type === 'Action') {
        this.transaction.status = 'Completed';
        this.transaction.type = 'Action';

      } else if (this.type === 'Follow') {
        this.transaction.status = 'In_progress';
        this.transaction.type = 'Follow';
      }
      const user = new User();

      if (this.action === 'completed') {
        this.transaction.status = 'Completed';

      }

      // alert(' this.transaction.actionDate==='+this.transaction.actionDate)
      // alert(' this.transaction.jalaliDate==='+this.transaction.jalaliDate)

      if (this.transaction.id !== undefined) {
        this.subscribeToSaveResponse(this.transactionService.update(this.transaction));
      } else {
        this.subscribeToSaveResponse(this.transactionService.createPeriodic(this.transaction));
      }


      if (this.type === 'Action') {
        this.transaction.status = 'Completed';
        this.transaction.type = 'Action';

      } else if (this.type === 'Follow') {
        this.transaction.status = 'In_progress';
        this.transaction.status = 'Follow';
      }
    }
  }

  sendAndUpdate() {
    this.isSaving = true;
    const user = new User();
    if (this.transaction.id !== undefined) {
      this.subscribeToSaveResponse_send(this.transactionService.update(this.transaction));
    } else {
      this.subscribeToSaveResponse_send(this.transactionService.create(this.transaction));
    }
  }

  protected subscribeToSaveResponse(result: Observable<HttpResponse<ITransaction>>) {
    result.subscribe((res: HttpResponse<ITransaction>) => this.onSaveSuccess(res.body), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected subscribeToSaveResponse_send(result: Observable<HttpResponse<ITransaction>>) {
    result.subscribe((res: HttpResponse<ITransaction>) => this.onSaveSuccess_send(res.body), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveSuccess(data) {
    this.eventService.onAddEvent('test message 22');

    this.isSaving = false;
    this.transaction = data;
    if (this.editFormFile.get(['content']).value) {
      this.saveFile();

    }
    if (this.type === 'Task') {
      this.isSavingTransaction = true;
    } else {

      if (this.chekNeedFollow === true) {
        this.type = 'Follow';
        this.action = 'add';

        this.transaction_new = new Transaction();
        this.transaction_new.customer = this.transaction.customer;
        if (this.transaction.customer) {
          this.customerId = this.transaction.customer.id;
        }
        if (this.transaction.project) {
          this.part = 'project';
          this.customer_project_param = this.transaction.project;
        }
        if (this.transaction.salesCycle) {
          this.part = 'salesCycle';
          this.customer_salesCycle_param = this.transaction.salesCycle;

        }
        this.transaction_new.audience = this.transaction.audience;
        this.transaction_new.actionDate = null;
        this.transaction_new.followupbyDate = null;
        this.transaction_new.jalaliDate = null;
        this.transaction_new.jalaliDateFollow = null;
        this.transaction_new.project = this.customer_project_param;
        this.transaction_new.salesCycle = this.customer_salesCycle_param;
        this.dateObject = null;
        this.dateObject_follow = null;
        this.dateObject2 = null;
        this.transaction = this.transaction_new;
        this.chekNeedFollow = false;
      } else {
        this.activeModal.dismiss('cancel');

      }

    }

  }


  protected subscribeToSaveResponseProject(result: Observable<HttpResponse<IProject>>) {
    result.subscribe((res: HttpResponse<IContract>) => this.onSaveSuccessProject(), (res: HttpErrorResponse) => this.onSaveError());
  }

  protected onSaveSuccessProject() {
    this.isSaving = false;
    this.clear();
  }


  protected onSaveSuccess_send(data) {

    this.isSaving = false;
    this.isSavingTransaction = true;
    this.transaction = data;
    this.activeModal.dismiss('cancel');

  }

  protected onSaveError() {
    this.isSaving = false;
  }

  protected onError(errorMessage: string) {
  }

  trackCustomerById(index: number, item: ICustomer) {
    return item.id;
  }


  clear() {
    this.activeModal.dismiss('cancel');
  }

  send() {
    this.sendAndUpdate();
  }


  loadCustomer() {
    if (this.customerId) {
      this.customerService.find(this.customerId).subscribe(
        (res: HttpResponse<ICustomer>) => {
          this.customer = res.body;
          this.transaction.customer = this.customer;
        },
        (res: HttpErrorResponse) => this.onError(res.message)
      );
    }
  }

  onChangesPeygiriChecked(deviceValue) {
    if (deviceValue.target.checked) {
      this.isDisabledPeygiri = false;
    } else {
      this.isDisabledPeygiri = true;
    }
  }


  addActionType(content) {

    const modalRef = this.modalService.open(ActionTypeUpdateComponent, {windowClass: 'lg', backdrop: 'static'});

    modalRef.result.then(
      res => {
        this.loadAllActionTypes();
      },
      rejected => {
        this.loadAllActionTypes();
      }
    );

  }


  uploadFile(event) {
    const file = (event.target as HTMLInputElement).files[0];
    this.form.patchValue({
      avatar: file
    });
    this.form.get('avatar').updateValueAndValidity();
  }

  submitUser() {
    this.isSaving = true;

    const fileObject = this.createFormFile();
    if (fileObject.id !== undefined && fileObject.id !== null) {
      this.subscribeToSaveResponseFile(this.fileObjectService.updateProfile(fileObject));
    } else {
      this.subscribeToSaveResponseFile(this.fileObjectService.createProfileImg(fileObject));
    }

  }


  private onSuccessProfile(data, headers) {
    this.fileObjects = data;
    this.totalItems = headers.get('X-Total-Count');
    if (this.fileObjects && this.fileObjects.length > 0) {
      this.profileImg = this.fileObjects[0];
      if (this.profileImg) {
        this.updateFormFile(this.profileImg);
      }
    }
  }

  myFunction(id) {
    const x = document.getElementById(id);

    if (x.style.display === 'none') {
      x.style.display = 'block';
    } else {
      x.style.display = 'none';
    }
  }


  showAdd() {
    this.showAddParam = true;
    this.createFormFile();
  }


  open(id) {

    this.fileObjectService.find(id).subscribe((res: HttpResponse<IFileObject>) => {
        this.file = res.body;
        const tabWindowId = window.open('about:blank', '_blank');
        tabWindowId.location.href = this.file.amazonLink;
      },
      (res: HttpErrorResponse) => console.log('______ error ______')
    );
  }

  updateFormFile(fileObject: IFileObject) {
    this.editFormFile.patchValue({
      id: fileObject.id,
      title: fileObject.title,
      content: fileObject.content,
      itemName: fileObject.contentType,
      size: fileObject.contentType,
      isImgProfile: fileObject.isImgProfile,
      imgProfile: fileObject.imgProfile,
      status: fileObject.status,
      uploaded_by: fileObject.uploaded_by,
      contentType: (this.action === 'approve' ? 'Approved' : fileObject.contentType)
    });
  }

  byteSize(field) {
  }

  openFile(contentType, field) {
  }

  setFileData(event, field: string, isImage) {
    const name = <HTMLInputElement>document.getElementById('file_content');


    this.file_itemName = name.files.item(0).name;
    this.file_size = name.files.item(0).size + '';
    this.file_fileType = name.files.item(0).type;

    return new Promise((resolve, reject) => {
      if (event && event.target && event.target.files && event.target.files[0]) {
        const file: File = event.target.files[0];
        if (isImage && !file.type.startsWith('image/')) {
          reject(`File was expected to be an image but was found to be ${file.type}`);
        } else {
          const filedContentType: string = field + 'ContentType';
          this.dataUtils.toBase64(file, base64Data => {
            this.editFormFile.patchValue({
              [field]: base64Data,
              [filedContentType]: file.type
            });
          });
        }
      } else {
        reject(`Base64 data was not set as file could not be extracted from passed parameter: ${event}`);
      }
    }).then(
      () => console.log('blob added'),
      this.onError
    );


  }


  hide() {
    this.showAddParam = false;
    this.createFormFile();
  }

  saveFile() {
    this.isSaving = true;
    this.progress = Math.round(200 / 200 * 100);
    const fileObject = this.createFormFile();
    fileObject.customer = new Customer(this.customerId);
    if (this.transaction) {
      fileObject.transaction = this.transaction;
    }
    if (this.transaction.project) {
      fileObject.project = this.transaction.project;
    }
    if (this.transaction.salesCycle) {
      fileObject.salesCycle = this.transaction.salesCycle;
    }
    if (fileObject.id !== undefined && fileObject.id !== null) {
      this.subscribeToSaveResponseFile(this.fileObjectService.update(fileObject));
    } else {
      this.subscribeToSaveResponseFile(this.fileObjectService.create(fileObject));
    }

  }

  approve() {
    this.isSaving = true;

    this.file_doctor.status = 'Approved';
    this.subscribeToSaveResponseFile(this.fileObjectService.update(this.file_doctor));

  }

  private createFormFile(): IFileObject {
    return {
      ...new FileObject(),
      id: this.editFormFile.get(['id']).value,
      title: (this.title === 'profileImg' ? 'عکس پروفایل' : this.editFormFile.get(['title']).value),
      uploaded_by: (this.role ? this.role : this.editFormFile.get(['uploaded_by']).value),
      contentType: this.file_fileType,
      itemName: this.file_itemName,
      size: this.file_size,
      isImgProfile: true,
      imgProfile: true,
      status: (this.accountService.hasAnyAuthority(['ROLE_ADMIN']) ? 'Approved' : 'Pending'),
      content: this.editFormFile.get(['content']).value
    };
  }


  protected subscribeToSaveResponseFile(result: Observable<HttpResponse<IFileObject>>) {
    result.subscribe(() => this.onSaveSuccessFile(), () => this.onSaveErrorFile());

  }

  protected onSaveSuccessFile() {
    this.isSaving = false;
    this.showAddParam = false;
    this.clear();
    this.toastr.success('.ثبت فایل شما با موفقیت انجام شد', '!موفق');

  }


  protected onSaveErrorFile() {
    this.isSaving = false;
  }


}
